import {ref} from 'vue'
import { axiosInstance as axios } from '@/plugins/axios'
import Swal from 'sweetalert2'
import {useFetchConfiguredCharges} from './fetch'

const { fetchConfiguredCharges } = useFetchConfiguredCharges()
const loading = ref(false)
export const useDeleteConfiguredCharge = () => {
	const deleteConfiguredCharge = (id) => {
		Swal.fire({
			icon: 'warning', title: 'Are you sure?', text: 'You won\'t be able to revert this!',
			showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33',
		}).then(async (result) => {
			if (result.isConfirmed) {
				loading.value = true
				try {
					const res = await axios.delete(`/v1/additional-charges/${id}`)
					if(res.data?.message == 'Deleted successfully') {
						Swal.fire({ icon: 'success', title: 'Success', text: res.data?.message || 'Configuration deleted successfully'})
						fetchConfiguredCharges()
					} else {
						Swal.fire({ icon: 'error', title: 'Error', text: res.data?.message ?? 'Could not delete configuration'})
					}
				} catch (err) {
					Swal.fire({ icon: 'error', title: 'Error', text: err?.response?.data?.message ?? 'An error occured'})
				} finally {
					loading.value = false
				}
			}
		})
		
	}

	return { loading, deleteConfiguredCharge }
}